import React from "react";
import { Helmet } from "react-helmet";
import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle14 from "../../randing/RandingStyle14";

function Randing318({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <>
      <Helmet>
        <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PLTBRFG5');`}</script>
      </Helmet>

      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-PLTBRFG5"
          height="0"
          width="0"
          title="gtm"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>

      <RandingStyle14
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        totalStep="2"
        img1Path={`${process.env.REACT_APP_CDN_BASE}/images/318/1.png`}
        img2Path={`${process.env.REACT_APP_CDN_BASE}/images/318/2.png`}
        img3Path={`${process.env.REACT_APP_CDN_BASE}/images/318/3.png`}
        img4Path={`${process.env.REACT_APP_CDN_BASE}/images/318/4.png`}
        img5Path={`${process.env.REACT_APP_CDN_BASE}/images/318/5.png`}
        img6Path={`${process.env.REACT_APP_CDN_BASE}/images/318/6.png`}
        question1={`${process.env.REACT_APP_CDN_BASE}/images/318/Q1.png`}
        question2={`${process.env.REACT_APP_CDN_BASE}/images/318/Q2.png`}
        question3={`${process.env.REACT_APP_CDN_BASE}/images/318/Q3.png`}
        btnOption1={`${process.env.REACT_APP_CDN_BASE}/images/318/option1`}
        btnOption2={`${process.env.REACT_APP_CDN_BASE}/images/318/option2`}
        btnOption3={`${process.env.REACT_APP_CDN_BASE}/images/318/option3`}
        btnOption4={`${process.env.REACT_APP_CDN_BASE}/images/318/option4`}
        btnOption5={`${process.env.REACT_APP_CDN_BASE}/images/318/option5`}
        btnOption6={`${process.env.REACT_APP_CDN_BASE}/images/318/option6`}
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/318/button.gif`}
        companyName="본원"
        noevent={true}
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
        apiUrl={apiUrl}
      />
    </>
  );
}

export default Randing318;
